export default "__VITE_ASSET__CzvlboNl__"